export default __webpack_public_path__ + "static/media/LENS_CULINARIS_DEFAULT_fragment_6.0c415df7.jpg";